import React, { useState, useEffect } from "react";
import InputField from "../../component/input-field";
import Select from "react-select";
import SimpleBarReact from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

// Importing sweet alert modal pop-up
import swal from "@sweetalert/with-react";
import CustomeModal from "../../component/modal-popup/customeModal";

import { useSelector, useDispatch } from "react-redux";
import { getTimeZoneForOnboarding } from "../../redux/actions/onboarding";

function OnboardingSlide2({ formik, setErrorForSlide2, errorForSlide2 }) {
  const [timeOptions, setTimeOptions] = useState([]);

  const user = useSelector((state) => state.auth);
  const { time_zone_for_onboarding } = useSelector((state) => state.onboarding);
  const dispatch = useDispatch();

  useEffect(() => {
    const request = {
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(getTimeZoneForOnboarding(request));
  }, []);

  useEffect(() => {
    if (time_zone_for_onboarding.length > 0) {
      const arr = [];
      time_zone_for_onboarding.map((element) => {
        const obj = {
          label: element.timezone,
          value: element.timezone_id,
        };
        arr.push(obj);
      });
      setTimeOptions(arr);
    }
  }, [time_zone_for_onboarding]);

  return (
    <div
      className="px-16 pt-16 space-y-4 h-full"
      style={{ maxHeight: "calc(100% - 80px)" }}
    >
      <div className="grid grid-cols-2 gap-4 h-full">
        <div className="space-y-6">
          <div className="block w-[60px]">
            <img
              alt="Logo"
              src={require("../../assets/img/ShiproneLogo.png")}
            />
          </div>
          <div>
            <p className="font-bold text-2xl leading-9 tracking-tight">
              Please Tell Us
            </p>
            <p className="font-bold text-2xl leading-9 tracking-tight">
              a Bit About <span className="text-[#2f80ed]">You</span>
            </p>
          </div>
          <div className="w-3/4">
            <p className="text-base font-medium leading-6 tracking-tight text-[#1E293B]">
              Let’s start with some details about you.
            </p>
          </div>
          <div>
            <a
              href="https://meetings.hubspot.com/abidwai/shiperone-workflow-demo"
              target="__blank"
              className="text-[#2f80ed] border-b border-[#2f80ed] font-semibold text-sm leading-10 tracking-tight py-2"
            >
              Schedule Personal Onboarding
            </a>
          </div>
        </div>
        <div className="lg:w-[85%] xl:w-[75%] overflow-x-hidden bg-[#F2F8FE] rounded-[20px] text-center p-4 lg:p-6 2xl:p-8">
          <div>
            <InputField
              type="text"
              label="Name"
              placeholder="Enter First Name"
              wrapperClass="text-left"
              name="first_name"
              onChange={(event) => {
                formik.setFieldValue("first_name", event.target.value);
              }}
              value={formik.values.first_name}
              onBlur={formik.handleBlur}
              error={
                Boolean(formik.touched.first_name && formik.errors.first_name)
                  ? formik.errors.first_name
                  : null
              }
            />
            <InputField
              type="text"
              placeholder="Enter Last Name"
              name="last_name"
              value={formik.values.last_name}
              wrapperClass="text-left -mt-1 mb-3"
              onChange={(event) => {
                formik.setFieldValue("last_name", event.target.value);
              }}
              onBlur={formik.handleBlur}
              error={
                Boolean(formik.touched.last_name && formik.errors.last_name)
                  ? formik.errors.last_name
                  : null
              }
            />
          </div>
          <InputField
            type="text"
            label="Email ID"
            placeholder="Enter Email ID"
            wrapperClass="my-3"
            value={user?.email}
            name="email"
            disabled
          />
          <InputField
            type="text"
            label="Phone Number (Optional)"
            placeholder="Enter Phone Number"
            wrapperClass="my-3 text-left"
            name="mobile_number"
            value={formik.values.mobile_number}
            onChange={(event) => {
              formik.setFieldValue("mobile_number", event.target.value);
            }}
            onBlur={formik.handleBlur}
            error={
              Boolean(
                formik.touched.mobile_number && formik.errors.mobile_number
              )
                ? formik.errors.mobile_number
                : null
            }
          />
          <div>
            <label
              className="block text-sm font-medium mb-1 mt-3 !text-left"
              htmlFor="country"
            >
              Time Zone
            </label>
            <Select
              className="unresetText text-left"
              placeholder="Select Time Zone"
              menuPortalTarget={document.body}
              menuPlacement="top"
              options={timeOptions}
              value={formik.values.time_zone}
              onChange={(timeZone) => {
                formik.setFieldValue("time_zone", timeZone);
                if (errorForSlide2) {
                  setErrorForSlide2(!errorForSlide2);
                }
              }}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
                placeholder: (provided, state) => ({
                  ...provided,
                  color: "#9B9B9B", // Set your desired color here
                }),
              }}
              classNames={{
                control: (style) => {
                  return `!border !shadow-sm ${
                    style.isFocused
                      ? "!border-[--bg-color-300]/50"
                      : "!border-slate-200 hover:!border-gray-300"
                  }`;
                },
                container: (style) => {
                  return "!h-[37.5px] !font-inter !text-sm";
                },
                menuList: (style) => {
                  return `!max-h-[200px]`;
                },
              }}
            />
            {errorForSlide2 && (
              <p className="text-xs text-rose-500 text-left">
                This field is required!
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnboardingSlide2;
